// removed by extract-text-webpack-plugin
module.exports = {"card":"LoadingView--card--8NsSIuRH","cardTitle":"LoadingView--cardTitle--22n5oCOz","label":"LoadingView--label--Fi2HdG9O"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/LoadingView/LoadingView.css
// module id = 1179
// module chunks = 2